import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import icon from '../../common/icon';

/**
 * A thumb-reach "start a discussion" button for phones.
 *
 * Core's own control lives in the index sidebar, which a phone collapses behind
 * the nav dropdown — so the action exists but is not where a reader looks. This
 * puts it on the discussion list, above the mobile tab bar.
 *
 * The action itself is copied from `IndexPage.newDiscussionAction()` so a guest
 * gets the same log-in prompt and a member the same composer.
 */
export default class NewDiscussionFab extends Component {
  view() {
    // The same capability rule core uses for its sidebar control: the forum
    // attribute is the permission, and a guest is allowed as far as the prompt.
    if (app.session.user && !app.forum.attribute('canStartDiscussion')) return null;

    // Nothing to add while an editor is already on screen.
    if (app.composer.isVisible()) return null;
    return m("button", {
      type: "button",
      className: "NewDiscussionFab",
      "aria-label": app.translator.trans('itqan-theme.forum.new_discussion.accessible_label'),
      onclick: () => this.start()
    }, icon('fas fa-pen'));
  }
  start() {
    if (app.session.user) {
      app.composer.load(() => flarum.reg.asyncModuleImport('flarum/forum/components/DiscussionComposer'), {
        user: app.session.user
      }).then(() => app.composer.show());
      return;
    }
    app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'));
  }
}
flarum.reg.add('itqan-theme', 'forum/components/NewDiscussionFab', NewDiscussionFab);